import React, { useEffect, useState, createElement, Component } from 'react';
import { LandingPage } from './pages/LandingPage';
import { InitiateAccessPage } from './pages/InitiateAccessPage';
import { BlueprintPage } from './pages/BlueprintPage';
import { AffiliateSignupPage } from './pages/AffiliateSignupPage';
import { CoreCurriculumPage } from './pages/CoreCurriculumPage';
import { AccountabilityPodsPage } from './pages/AccountabilityPodsPage';
import { AIToolsPage } from './pages/AIToolsPage';
import { ContentFrameworkPage } from './pages/ContentFrameworkPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { SitemapPage } from './pages/SitemapPage';
import { AIResearchMasteryPage } from './pages/AIResearchMasteryPage';
import { AIResearchBlueprintPage } from './pages/AIResearchBlueprintPage';
import { AIResearchAssessmentPage } from './pages/AIResearchAssessmentPage';
import { DrillingPotPage } from './pages/DrillingPotPage';
import { NetworkingSalonExperiencePage } from './pages/NetworkingSalonExperiencePage';
export function App() {
  const [currentPage, setCurrentPage] = useState(window.location.pathname);
  const handleNavigate = (path: string) => {
    // Split path and hash
    const [pathname, hash] = path.split('#');
    setCurrentPage(pathname);
    window.history.pushState({}, '', path);
    // Handle scrolling
    if (hash) {
      // Wait for render cycle to complete before scrolling to element
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  };
  // Handle browser back/forward buttons
  useEffect(() => {
    const handlePopState = () => {
      setCurrentPage(window.location.pathname);
      window.scrollTo(0, 0);
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);
  // Load Paystack script on mount
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.paystack.co/v1/inline.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  // Route mapping
  const routes: {
    [key: string]: JSX.Element;
  } = {
    '/': <LandingPage onNavigate={handleNavigate} data-id="element-0" />,
    '/blueprint': <BlueprintPage onNavigate={handleNavigate} data-id="element-1" />,
    '/join': <InitiateAccessPage onNavigate={handleNavigate} data-id="element-2" />,
    '/initiate-access': <InitiateAccessPage onNavigate={handleNavigate} data-id="element-3" />,
    '/affiliate-signup': <AffiliateSignupPage onNavigate={handleNavigate} data-id="element-4" />,
    '/affiliate': <AffiliateSignupPage onNavigate={handleNavigate} data-id="element-5" />,
    '/core-curriculum': <CoreCurriculumPage onNavigate={handleNavigate} data-id="element-6" />,
    '/curriculum': <CoreCurriculumPage onNavigate={handleNavigate} data-id="element-7" />,
    '/accountability-pods': <AccountabilityPodsPage onNavigate={handleNavigate} data-id="element-8" />,
    '/pods': <AccountabilityPodsPage onNavigate={handleNavigate} data-id="element-9" />,
    '/ai-tools': <AIToolsPage onNavigate={handleNavigate} data-id="element-10" />,
    '/ai': <AIToolsPage onNavigate={handleNavigate} data-id="element-11" />,
    '/content-framework': <ContentFrameworkPage onNavigate={handleNavigate} data-id="element-12" />,
    '/framework': <ContentFrameworkPage onNavigate={handleNavigate} data-id="element-13" />,
    '/terms': <TermsPage onNavigate={handleNavigate} data-id="element-14" />,
    '/privacy': <PrivacyPage onNavigate={handleNavigate} data-id="element-15" />,
    '/sitemap': <SitemapPage onNavigate={handleNavigate} data-id="element-16" />,
    '/pages': <SitemapPage onNavigate={handleNavigate} data-id="element-17" />,
    '/ai-research-mastery': <AIResearchMasteryPage onNavigate={handleNavigate} data-id="element-18" />,
    '/ai-research-blueprint': <AIResearchBlueprintPage onNavigate={handleNavigate} data-id="element-19" />,
    '/ai-research-assessment': <AIResearchAssessmentPage onNavigate={handleNavigate} data-id="element-20" />,
    '/lounge': <AIResearchAssessmentPage onNavigate={handleNavigate} data-id="element-21" />,
    '/drilling-pot': <DrillingPotPage onNavigate={handleNavigate} data-id="element-22" />,
    '/networking-salon-experience': <NetworkingSalonExperiencePage onNavigate={handleNavigate} data-id="element-23" />,
    '/salon': <NetworkingSalonExperiencePage onNavigate={handleNavigate} data-id="element-24" />
  };
  // Get the current page component or show 404
  const currentComponent = routes[currentPage] || routes['/'];
  return currentComponent;
}